import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import store from './store.js'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'

import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"


import "chart.js"
import "hchs-vue-charts"

Vue.use(window.VueCharts)
// Vue.config.productionTip = true

var filter = function(text, length, clamp){
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
Vue.filter('truncate', filter)
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

window.firebase = firebase;

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')